





































import { defineComponent } from "@vue/composition-api";
import Expandable from "@/components/Expandable.vue";
import { BlockLabel } from "@/models/BlockLabel";

export default defineComponent({
  name: "RegistrationDiscount",
  components: {
    Expandable,
  },
  props: {
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      displayName: BlockLabel.RegistrationDiscount,
      percentFirstHalfYear: 50,
      percentSecondHalfYear: 100,
    };
  },
  mounted() {
    if (this.data) {
      this.percentFirstHalfYear = this.data.percentFirstHalfYear;
      this.percentSecondHalfYear = this.data.percentSecondHalfYear;
    }
  },
  methods: {
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock() {
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        percentFirstHalfYear: this.percentFirstHalfYear,
        percentSecondHalfYear: this.percentSecondHalfYear,
      });
    },
  },
});
